<template>
  <section>
    <article>
      <header>
        <h2>Modal</h2>
      </header>
      <button @click="toggle('modal')">Show modal</button>
      <transition name="modal">
        <div class="modal-mask" v-if="isHidden('modal')">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-body">
                <p>Modal body</p>
                <button @click="toggle('modal')">Looks good</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </article>
  </section>
</template>

<script>
import toggleVisibility from "../mixins/toggleVisibility.js";
export default {
  mixins: [toggleVisibility]
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-body {
  margin: 20px 0;
}

/* Animation part */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>